import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PopupBtmNotCallNumber from "./components/car/PopupBtmNotCallNumber";
import { mockData } from "../util/mockData";
import { useRecoilState } from 'recoil';
import { carInfoState } from '../recoil/atom';

const Car = () => {
  const navigate = useNavigate();
  const [carInfo, setCarInfo] = useRecoilState(carInfoState);
  const [carNumber, setCarNumber] = useState(carInfo?.carNumber || "");
  const [isCallToCar, setisCallToCar] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [hasModified, setHasModified] = useState(false);

  /*
  \d{2,3}[가-힣]\d{4}: 일반 차량 번호판 (예: 12가1234, 123가1234)
  \d{2}[가-힣]{2}\d{4}: 특수 차량 번호판 (예: 12서울1234)
  \d{2}[가-힣]\d{4}: 더 단순한 번호판 형식 (예: 12가1234)
  */
  const carNumberRegex = /^(\d{2,3}[가-힣]\d{4}|\d{2}[가-힣]\d{4}|\d{2}[가-힣]{2}\d{4})$/;

  const resetCarNumber = () => {
    setCarNumber("");
    setisCallToCar(null);
  }

  useEffect(() => {
    const checkCarNumber = () => {
      if (carNumberRegex.test(carNumber)) {
        setIsLoading(true);
        const foundCar = mockData.car.find(car => car.carNumber === carNumber);
        
        if (carNumber === carInfo?.carNumber) {
          setisCallToCar(true);
          setTimeout(() => {
            navigate('/chatbot');
          }, 1000);
        } else {
          setisCallToCar(foundCar !== undefined);
          if (foundCar && hasModified) {
            setCarInfo({
              carNumber: carNumber,
              carName: '',
              carScale: '',
              carYear: '',
              carRegion: '',
              carReservationDate: '',
              carRepairPart: '',
              userName: '',
              userPhoneNumber: '',
              userRequest: ''
            });
          }
        }
        setIsLoading(false);
      }
    };

    if (hasModified) {
      const timeoutId = setTimeout(() => {
        if (carNumber) {
          checkCarNumber();
        }
      }, 500);
      return () => clearTimeout(timeoutId);
    }
  }, [carNumber, navigate, carInfo, setCarInfo, hasModified]);



  const handleInputChange = (e) => {
    const value = e.target.value.replace(/\s+/g, ''); // 띄어쓰기 제거
    setCarNumber(value);
    setHasModified(true);

    if (!carNumberRegex.test(value)) {
      setisCallToCar(null);
    }
  };

  return (
    <>
      <div className="w-full h-[100vh] min-h-full bg-[#1B1C1E]">
        <header className="relative z-10 pt-3 text-base text-center">
          <span className="text-white">한국손해보상서비스(주)</span>
        </header>

        <div className="relative z-10 p-6 pb-6 pt-44">
          <img src="/assets/img/ico_warning.svg" alt="warning" className="pb-4" />
          <img src="/assets/img/txt-today.svg" alt="img" className="pb-4" />
          <p className="pb-8 text-white">
            지금 하지 않으면{" "}
            <span className="text-[#FE9342]">
              산화, 부식, 녹, 갈라짐, 벗져김 등
            </span>
            <br />
            빠르게 차의 수명이 단축될 수 있습니다.
          </p>

          <div className="bg-[#292A2D] rounded-base p-6 border border-[#525252]">
            <p className="text-[#C2C4C8] pb-4">
              차량 번호를 입력하면 바로 수리 가능한
              <br />
              공장을 확인할 수 있습니다.
            </p>

            <div className="relative">
              <input
                type="text"
                className="bg-[#fff] h-70 w-full rounded-base text-22 pl-5 placeholder-[#C2C4C8] font-semibold"
                placeholder="38무 0874"
                value={carNumber}
                onChange={handleInputChange}
              />

              { carNumberRegex.test(carNumber) &&
                <img
                  src="/assets/img/input-check.svg"
                  alt="check"
                  className="absolute right-6 top-7"
                />
              }

              {
                carNumber.length > 0 && (
                  <p
                    className={`text-[13px] ${
                      carNumberRegex.test(carNumber)
                        ? "text-[#878A92]"
                        : "text-[#E95C4F]"
                    } pt-[10px]`}
                  >
                    { carNumberRegex.test(carNumber)
                      ? "차량 정보를 불러들입니다.."
                      : "차량번호 형식을 확인해 주세요."
                    }
                  </p>
                )
              }
            </div>
          </div>

          <p className="text-[#70737B] text-center text-[13px] pt-[34px]">
            본 서비스는 자동차 보험사고로 인한 수리를 위해
            <br />
            안내해드리는 다이렉트 보상 서비스입니다.
          </p>
        </div>

        <img
          src="/assets/img/car_bg.png"
          alt="img"
          className="absolute top-0 left-0 w-screen h-96"
        />
      </div>
      {hasModified && isCallToCar === false && 
        <PopupBtmNotCallNumber carNumber={carNumber} resetCarNumber={resetCarNumber} />
      }
    </>
  );
};

export default Car;